import { DateTime } from 'luxon';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'fixDate',
  standalone: false
})
export class FixDate implements PipeTransform {

  constructor(private translateService: TranslationService) { }

  transform(value: Date | string | any, optionFormat?: number): string {
    if (!value) return '--';

    // Formatos de fecha
    const formatDate = optionFormat === 2 ? 'dd/LL/yyyy' : 'dd/LLL/yyyy';

    let dateTime: DateTime;

    try {
      if (value instanceof Date) {
        // Parseamos la fecha como UTC para evitar desfase al guardar
        dateTime = DateTime.fromJSDate(value, { zone: 'utc' });
      } else if (typeof value === 'string') {
        // Intentamos ISO primero
        dateTime = DateTime.fromISO(value, { zone: 'utc' });

        // Si falla, intentamos formato dd/MM/yyyy HH:mm:ss o dd/MM/yyyy
        if (!dateTime.isValid) {
          dateTime = DateTime.fromFormat(value, 'dd/LL/yyyy HH:mm:ss', { zone: 'utc' });
          if (!dateTime.isValid) {
            dateTime = DateTime.fromFormat(value, 'dd/LL/yyyy', { zone: 'utc' });
          }
        }
      } else {
        return '--';
      }

      if (!dateTime.isValid) return '--';

      const locale = this.translateService?.currentLang || 'es';
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Convertimos a zona local solo al mostrar
      return dateTime
        .setLocale(locale)
        .toFormat(formatDate)
        .toUpperCase();

    } catch (error) {
      console.error('Error en FixDate pipe:', error);
      return '--';
    }
  }
}
